import { Box, Flex, Image, SimpleGrid, Stack, Text } from "@chakra-ui/react";

import ArrowButton from "../../../components/animatedArrow/animatedArrowButton";
import { useNavigate } from "react-router-dom";
import { TbCalendarEvent } from "react-icons/tb";
import { HiOutlineUserCircle } from "react-icons/hi";
import dayjs from "dayjs";

const BlogCard = ({ blog, vertical }) => {
  const navigate = useNavigate();
  return (
    <Box
      maxW={vertical ? "100%" : "400px"}
      minW={vertical ? 0 : ["300px", "350px"]}
      flex="1"
      data-aos="fade-up"
      bg="#fff"
      borderRadius="20px"
      border="1px solid #EDE7F4"
      boxShadow="0 10px 30px rgba(41,15,68,0.07)"
      overflow="hidden"
      transition="all .25s ease-in-out"
      _hover={{ transform: "translateY(-6px)", boxShadow: "0 18px 40px rgba(41,15,68,0.14)" }}
    >
      <Box overflow={"hidden"}>
        <Image
          loading="lazy"
          transition="all .2s ease-in-out"
          _hover={{ transform: "scale(1.1)" }}
          objectFit={"cover"}
          w="100%"
          h="250px"
          src={blog.image}
          alt={blog.imageAlt || blog.title}
        />
      </Box>

      <Box padding="1.2rem 1.4rem 1.6rem">
        <Stack
          w="100%"
          flexWrap="wrap"
          mb={3}
          alignItems="center"
          justifyContent={vertical ? "flex-start" : "space-between"}
          spacing="20px"
          direction={"row"}
        >
          <Stack direction={"row"} alignItems="center">
            <TbCalendarEvent color="#434144" />
            <Text color="#100120" fontSize=".9rem">
              {dayjs(blog.createdAt).format("MMMM DD YYYY")}
            </Text>
          </Stack>

          <Stack direction={"row"} alignItems="center">
            <HiOutlineUserCircle color="#434144" />
            <Text color="#100120" fontSize=".9rem">
              {blog.author}
            </Text>
          </Stack>
        </Stack>
        <Text
          mb={3}
          maxWidth="100%"
          fontSize="1.3rem"
          lineHeight="26px"
          fontWeight="500"
          color="#100120"
        >
          {blog.title}
        </Text>
        {vertical && (
          <Text mb={3} maxWidth="100%" fontSize=".95rem" lineHeight="22px" color="#434144">
            {blog.excerpt}
          </Text>
        )}
        <ArrowButton
          text="Read More"
          color="#05C97A"
          onClick={() => navigate(`/blog/${blog.slug}`)}
        />
      </Box>
    </Box>
  );
};

const BlogCards = ({ blogs = [], vertical = false }) => {
  return (
    <Box marginTop="50px">
      {vertical ? (
        <SimpleGrid columns={[1, 1, 2, 3]} spacing="30px" alignItems="stretch">
          {blogs.map((blog) => (
            <BlogCard key={blog.slug} blog={blog} vertical />
          ))}
        </SimpleGrid>
      ) : (
        <Flex
          gap="2.5rem"
          alignItems="flex-start"
          justifyContent="space-between"
          overflowX="scroll"
        >
          {blogs.map((blog) => (
            <BlogCard key={blog.slug} blog={blog} />
          ))}
        </Flex>
      )}
    </Box>
  );
};

export default BlogCards;
